import { module } from 'angular';
import { NgModule } from 'angular-ts-decorators';

import { DesignModule } from 'src/Foundation/Design/platform/app/module';
import { ProductApiModule } from 'src/Foundation/ProductApi/platform/Scripts/module';
import { TranslationModule } from 'src/Foundation/Translation/platform/app/module';

import { AccessoriesSpotController } from './accessories-spot/accessories-spot.controller';
import { BuyButtonService } from './buy-button/buy-button.service';
import { CgCustomizerController } from './cg-customizer-spot/cg-customizer.controller';
import { FamilyCustomizerController } from './family-customizer-spot/family-customizer.controller';
import { HeroCustomizerController } from './hero-customizer-spot/hero-customizer.controller';
import { NonProductSpotController } from './non-product-spot/non-product-spot.controller';
import { RelatedProductsConfigurationController } from './related-products-spot/related-products-configuration.controller';
import { RelatedProductsController } from './related-products-spot/related-products-spot.controller';
import { ShopRibbonController } from './shop-ribbon-spot/shop-ribbon.controller';

import { CgCustomizerAccessoriesComponent } from './cg-customizer-accessories/cg-customizer-accessories.component';
import { CgCustomizerAddToCartComponent } from './cg-customizer-add-to-cart/cg-customizer-add-to-cart.component';
import { CgCustomizerModelSelectionComponent } from './cg-customizer-model-selection/cg-customizer-model-selection.component';
import { CgCustomizerProductComponent } from './cg-customizer-product/cg-customizer-product.component';
import { CgCustomizerTotalComponent } from './cg-customizer-total/cg-customizer-total.component';

import { BuyButtonComponent } from './buy-button/buy-button.component';
import { CondensedMenuDirective } from './condensed-menu-spot/condensed-menu.directive';
import { CustomizerButtonsComponent } from './customizer-buttons/customizer-buttons.component';
import { FindRetailerComponent } from './find-retailer/find-retailer.component';
import { LowestMonthPriceComponent } from './lowest-month-price/lowest-month-price.component';
import { OfferCountdownComponent } from './offer-countdown/offer-countdown.component';
import { ProductEngravingFormComponent } from './product-engraving/product-engraving-form.component';
import { ProductStateLabelComponent } from './product-state-label/product-state-label.component';
import { BuyExclusivelyComponent } from './retailers/buy-exclusively/buy-exclusively.component';
import { RetailerLocatorComponent } from './retailers/retailer-locator/retailer-locator.component';
import { UniqueSellingPointComponent } from './unique-selling-point/unique-selling-point.component';

import { ElevateZoomDirective } from './directives/elevate-zoom.directive';
import { FadeOutOnBgChangeDirective } from './directives/fade-out-on-bg-change.directive';
import { FadeOutOnSrcChangeDirective } from './directives/fade-out-on-src-change.directive';
import { ShowMoreToggleDirective } from './directives/show-more-toggle.directive';

import { OfferCountdownService } from './offer-countdown/offer-countdown.service';
import { CustomizerFilterService } from './services/customizer-filter.service';

import { CustomizerProductInfoModule } from './customizer-product-info/module';

import { HeroCustomizerV2Module } from './hero-customizer-v2/module';
import { HeroCustomizerV3Module } from './hero-customizer-v3/module';

const moduleId = 'gn.audio.public.productcatalogue';
const legacyModuleId = `${moduleId}.legacy`;

module(legacyModuleId, [])
  .controller('AccessoriesSpotController', AccessoriesSpotController)
  .controller('CgCustomizerController', CgCustomizerController)
  .controller('FamilyCustomizerController', FamilyCustomizerController)
  .controller('HeroCustomizerController', HeroCustomizerController)
  .controller('NonProductSpotController', NonProductSpotController)
  .controller('RelatedProductsConfigurationController', RelatedProductsConfigurationController)
  .controller('RelatedProductsController', RelatedProductsController)
  .controller('ShopRibbonController', ShopRibbonController);

@NgModule({
  declarations: [
    BuyButtonComponent,
    BuyExclusivelyComponent,
    CgCustomizerAccessoriesComponent,
    CgCustomizerAddToCartComponent,
    CgCustomizerModelSelectionComponent,
    CgCustomizerProductComponent,
    CgCustomizerTotalComponent,
    CustomizerButtonsComponent,
    FindRetailerComponent,
    LowestMonthPriceComponent,
    OfferCountdownComponent,
    ProductEngravingFormComponent,
    ProductStateLabelComponent,
    RetailerLocatorComponent,
    UniqueSellingPointComponent,

    CondensedMenuDirective,
    FadeOutOnBgChangeDirective,
    FadeOutOnSrcChangeDirective,
    ShowMoreToggleDirective,
    ElevateZoomDirective,
  ],
  id: moduleId,
  imports: [
    ProductApiModule,
    legacyModuleId,
    DesignModule,
    TranslationModule,
    CustomizerProductInfoModule,

    HeroCustomizerV2Module,
    HeroCustomizerV3Module,
  ],
  providers: [
    CustomizerFilterService,
    OfferCountdownService,
    BuyButtonService,
  ],
})
export class ProductCatalogueModule {
}
